import { _ as _asyncToGenerator, a as _regeneratorRuntime } from './asyncToGenerator-9cc1acb2.esm.js';
import { _ as _objectSpread2 } from './objectSpread2-04e3d2b4.esm.js';
import { a as _createClass, _ as _classCallCheck } from './createClass-38c45ab6.esm.js';
import { _ as _defineProperty } from './defineProperty-6a97efcd.esm.js';
import { subscribeWithSelector, persist } from 'zustand/middleware';
import create from 'zustand/vanilla';
import { c as createStorage, n as noopStorage } from './storage-057d54ab.esm.js';

var storeKey = 'livepeer-store';
var Client = /*#__PURE__*/function () {
  function Client(_ref) {
    var provider = _ref.provider,
      _ref$storage = _ref.storage,
      storage = _ref$storage === void 0 ? createStorage({
        storage: noopStorage
      }) : _ref$storage;
    _classCallCheck(this, Client);
    _defineProperty(this, "config", void 0);
    _defineProperty(this, "storage", void 0);
    _defineProperty(this, "store", void 0);
    // Create store
    this.store = create(subscribeWithSelector(persist(function () {
      return {
        provider: provider()
      };
    }, {
      name: storeKey,
      getStorage: function getStorage() {
        return storage;
      },
      // for now, we don't store any state in local storage
      partialize: function partialize(_state) {
        return {};
      },
      version: 1
    })));
    this.config = {
      provider: provider,
      storage: storage
    };
    this.storage = storage;
  }
  _createClass(Client, [{
    key: "error",
    get: function get() {
      return this.store.getState().error;
    }
  }, {
    key: "provider",
    get: function get() {
      return this.store.getState().provider;
    }
  }, {
    key: "subscribe",
    get: function get() {
      return this.store.subscribe;
    }
  }, {
    key: "setState",
    value: function setState(updater) {
      var newState = typeof updater === 'function' ? updater(this.store.getState()) : updater;
      this.store.setState(newState, true);
    }
  }, {
    key: "clearState",
    value: function clearState() {
      this.setState(function (x) {
        return _objectSpread2(_objectSpread2({}, x), {}, {
          data: undefined,
          error: undefined
        });
      });
    }
  }, {
    key: "destroy",
    value: function () {
      var _destroy = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.clearState();
                this.store.destroy();
              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
      function destroy() {
        return _destroy.apply(this, arguments);
      }
      return destroy;
    }()
  }]);
  return Client;
}();
var client = null;
function createClient(config) {
  var client_ = new Client(config);
  client = client_;
  return client_;
}
function getClient() {
  if (!client) {
    throw new Error('No livepeer client found.');
  }
  return client;
}
function clearClient() {
  client = null;
}

export { Client as C, createClient as a, clearClient as c, getClient as g };
